import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M18.9999 12H16.9999V15H13.9999V17H18.9999V12ZM6.99988 9H9.99988V7H4.99988V12H6.99988V9ZM20.9999 3H2.99988C1.89988 3 0.999878 3.9 0.999878 5V19C0.999878 20.1 1.89988 21 2.99988 21H20.9999C22.0999 21 22.9999 20.1 22.9999 19V5C22.9999 3.9 22.0999 3 20.9999 3ZM20.9999 19.01H2.99988V4.99H20.9999V19.01Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.50006 4.06506C3.25981 4.06506 3.06506 4.25981 3.06506 4.50006V11.5001C3.06506 11.7403 3.25981 11.9351 3.50006 11.9351H12.5001C12.7403 11.9351 12.9351 11.7403 12.9351 11.5001V4.50006C12.9351 4.25981 12.7403 4.06506 12.5001 4.06506H3.50006ZM1.93506 4.50006C1.93506 3.63573 2.63573 2.93506 3.50006 2.93506H12.5001C13.3644 2.93506 14.0651 3.63573 14.0651 4.50006V11.5001C14.0651 12.3644 13.3644 13.0651 12.5001 13.0651H3.50006C2.63573 13.0651 1.93506 12.3644 1.93506 11.5001V4.50006ZM5 6H6.5C6.77614 6 7 5.77614 7 5.5C7 5.22386 6.77614 5 6.5 5H4.7C4.3134 5 4 5.3134 4 5.7V7.5C4 7.77614 4.22386 8 4.5 8C4.77614 8 5 7.77614 5 7.5V6ZM12 8.5C12 8.22386 11.7761 8 11.5 8C11.2239 8 11 8.22386 11 8.5V10H9.5C9.22386 10 9 10.2239 9 10.5C9 10.7761 9.22386 11 9.5 11H11.3C11.6866 11 12 10.6866 12 10.3V8.5Z"
  />
);

export const ColumnExpandIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="ColumnExpand" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
